import React, { useCallback, useEffect } from "react";

// components
import Paginate from "../../../components/ui/paginate";

// state
import { setTitle } from "../../../store/slices/navbar";
import { setRequestOffset } from "../../../store/slices/request";
import { useAppDispatch, useAppSelector } from "../../../store";
import AnimatedPage from "../../../components/animation/AnimatedPage";
import RequestCard from "../misc/RequestCard";
import MobileRequestCard from "../misc/MobileRequestCard";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
import { get_service_requests } from "../../../service/api/requests";
import { Loader } from "../../../components/animation/Loader";

const RequestDashboard = () => {
  const dispatch = useAppDispatch();
  const { requests, limit, offset, total, loading } = useAppSelector(
    ({ serviveRequest }) => serviveRequest,
  );

  const isMobile = useMediaQuery("(max-width: 768px)");
  const current_page = Math.floor(offset / limit) + 1;
  const last_page = Math.max(1, Math.ceil(total / limit));

  const onLoad = useCallback(() => {
    dispatch(setTitle("Requests"));
    get_service_requests(dispatch, { limit, offset });
  }, [limit, offset, dispatch]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  if (loading && requests.length === 0) {
    return <Loader />;
  }

  return (
    <AnimatedPage>
      <main className="w-full">
        <div className="pb-12">
          {requests.length > 0 ? (
            <div className="space-y-4">
              {requests.map((item) =>
                isMobile ? (
                  <MobileRequestCard key={item.id} item={item} />
                ) : (
                  <RequestCard key={item.id} item={item} />
                ),
              )}
            </div>
          ) : (
            <div className="flex justify-center items-center h-[400px] bg-white rounded-lg shadow-sm">
              <div className="text-center">
                <p className="text-gray-500 text-lg">No requests found</p>
                <p className="text-gray-400 text-sm mt-2">
                  You haven't made any requests yet
                </p>
              </div>
            </div>
          )}
        </div>

        {requests.length > 0 && (
          <Paginate
            current_page={current_page}
            last_page={last_page}
            disabled={loading}
            onBack={() =>
              dispatch(setRequestOffset(Math.max(0, offset - limit)))
            }
            onNext={() => {
              if (current_page < last_page) {
                dispatch(setRequestOffset(offset + limit));
              }
            }}
          />
        )}
      </main>
    </AnimatedPage>
  );
};

export default RequestDashboard;
